import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/Lauout/OperationOverview'
    },
    {
      path: '/Lauout',
      name: 'Layout',
      component: () => import(/* webpackChunkName: "Lauout" */ '../views/Layout.vue'),
      children: [
        {
          path: 'BasicData',
          name: 'BasicData',
          component: () => import(/* webpackChunkName: "BasicData" */ '../views/BasicData/index.vue'),
          children: [
            {
              path: 'BuildingManagement',
              name: 'BuildingManagement',
              component: () =>
                import(/* webpackChunkName: "BasicData" */ '../views/BasicData/BuildingManagement/index.vue'),
              meta: {
                title: '同步课堂网管理中心-基础数据-楼栋管理',
                index: 2,
                documentTitle: '同步课堂_楼栋管理'
              }
            },
            {
              path: 'ClassRoomManagement',
              name: 'ClassRoomManagement',
              component: () =>
                import(/* webpackChunkName: "BasicData" */ '../views/BasicData/ClassroomManagement/index.vue'),
              meta: {
                title: '同步课堂网管理中心-基础数据-教室管理',
                index: 2,
                keepAlive: true,
                documentTitle: '同步课堂_教室管理'
              }
            },
            {
              path: 'ClassroomDetail',
              name: 'ClassroomDetail',
              component: () =>
                import(
                  /* webpackChunkName: "ClassroomDetail" */ '../views/BasicData/ClassroomManagement/classroomDetail.vue'
                ),
              meta: {
                title: '同步课堂网管理中心-教室管理-教室详情',
                index: 2,
                documentTitle: '同步课堂_教室详情'
              }
            },
            {
              path: 'organizationalManagement',
              name: 'OrganizationalManagement',
              component: () =>
                import(/* webpackChunkName: "BasicData" */ '../views/BasicData/OrganizationalManagement/index.vue'),
              meta: {
                title: '同步课堂网管理中心-基础数据-机构管理',
                index: 2,
                keepAlive: true,
                documentTitle: '同步课堂_机构管理'
              }
            }
          ]
        },
        {
          path: 'OrganizationManagement',
          name: 'OrganizationManagement',
          component: () =>
            import(/* webpackChunkName: "OrganizationManagement" */ '../views/OrganizationManagement.vue'),
          children: [
            // {
            //   path: "ClassRoomManagement",
            //   name: "ClassRoomManagement",
            //   component: () => import(/* webpackChunkName: "OrganizationManagement" */ '../views/OrganizationManagement/ClassRoomManagement.vue'),
            //   meta: {
            //     title: "同步课堂网管理中心-机构管理-教室管理",
            //     index: 2,
            //     documentTitle: "同步课堂_教室管理"
            //   }
            // },
            {
              path: 'EquipmentManagement',
              name: 'EquipmentManagement',
              component: () =>
                import(
                  /* webpackChunkName: "OrganizationManagement" */ '../views/OrganizationManagement/EquipmentManagement.vue'
                ),
              meta: {
                title: '同步课堂网管理中心-机构管理-设备管理',
                index: 2,
                documentTitle: '同步课堂_设备管理'
              }
            },
            {
              path: 'TeacherManagement',
              name: 'TeacherManagement',
              component: () =>
                import(
                  /* webpackChunkName: "OrganizationManagement" */ '../views/OrganizationManagement/TeacherManagement.vue'
                ),
              meta: {
                title: '同步课堂网管理中心-机构管理-教师管理',
                index: 2,
                documentTitle: '同步课堂_教师管理'
              }
            }
          ]
        },
        {
          path: 'PrintPage',
          name: 'PrintPage',
          component: () => import(/* webpackChunkName: "PrintPage" */ '../views/PrintPage.vue'),
          meta: {
            title: '同步课堂网管理中心-机构管理-教室管理-打印二维码',
            index: 2,
            documentTitle: '同步课堂_打印二维码'
          }
        },
        {
          path: 'LiveStreamingList',
          name: 'LiveStreamingList',
          component: () =>
            import(/* webpackChunkName: "LiveStreamingList" */ '../views/CourseManagement/LiveStreamingList/index.vue'),
          meta: {
            title: '同步课堂网管理中心-课程管理-直播列表',
            index: 2,
            documentTitle: '同步课堂_直播列表'
          }
        },
        {
          path: 'CourseList',
          name: 'CourseList',
          component: () => import(/* webpackChunkName: "CourseList" */ '../views/CourseManagement/CourseList.vue'),
          meta: {
            title: '同步课堂网管理中心-课程管理-课程列表',
            index: 2,
            keepAlive: true,
            documentTitle: '同步课堂_课程列表'
          }
        },
        {
          path: 'CourseListDetail',
          name: 'CourseListDetail',
          component: () =>
            import(/* webpackChunkName: "CourseListDetail" */ '../views/CourseManagement/CourseListDetail.vue'),
          meta: {
            title: '同步课堂网管理中心-课程管理-课程详情',
            index: 2,
            documentTitle: '同步课堂_课程详情'
          }
        },
        {
          path: 'ActiveList',
          name: 'ActiveList',
          component: () => import(/* webpackChunkName: "ActiveList" */ '../views/CourseManagement/ActiveList.vue'),
          meta: {
            title: '同步课堂网管理中心-课程管理-活动列表',
            index: 2,
            keepAlive: true,
            documentTitle: '同步课堂_活动列表'
          }
        },
        {
          path: 'ActiveListDetail',
          name: 'ActiveListDetail',
          component: () =>
            import(/* webpackChunkName: "ActiveListDetail" */ '../views/CourseManagement/ActiveListDetail.vue'),
          meta: {
            title: '同步课堂网管理中心-课程管理-活动详情',
            index: 2,
            documentTitle: '同步课堂_活动详情'
          }
        },
        {
          path: 'ActiveListDetailSpoc',
          name: 'ActiveListDetailSpoc',
          component: () =>
            import(
              /* webpackChunkName: "ActiveListDetail" */ '../views/CourseManagement/activity/ActiveListDetailSpoc.vue'
            ),
          meta: {
            title: '同步课堂网管理中心-课程管理-活动详情',
            index: 2,
            documentTitle: '同步课堂_活动详情'
          }
        },
        {
          path: 'VideoSliceList',
          name: 'VideoSliceList',
          component: () =>
            import(/* webpackChunkName: "VideoSliceList" */ '../views/CourseManagement/VideoSliceList.vue'),
          meta: {
            title: '同步课堂网管理中心-课程管理-视频切片列表',
            index: 2,
            // keepAlive: true,
            documentTitle: '同步课堂_视频切片列表'
          }
        },
        {
          path: 'OperationOverview',
          name: 'OperationOverview',
          // component: () => import(/* webpackChunkName: "OperationOverview" */ '../views/OperationOverview/OperationOverview.vue'),
          component: () => import(/* webpackChunkName: "OperationOverview" */ '../views/OperationOverview/index.vue'),
          meta: {
            title: '同步课堂网管理中心-运行概况',
            index: 2,
            documentTitle: '同步课堂_运行概况'
          }
        },
        {
          path: 'DataScreen',
          name: 'DataScreen',
          component: () => import(/* webpackChunkName: "DataScreen" */ '../views/DataScreen/index.vue'),
          meta: {
            title: '同步课堂网管理中心-课堂大屏配置',
            index: 2,
            documentTitle: '同步课堂_课堂大屏配置'
          }
        },
        {
          path: 'CatalogConfig',
          name: 'CatalogConfig',
          component: () => import(/* webpackChunkName: "CatalogConfig" */ '../views/CatalogConfig/index.vue'),
          meta: {
            title: '同步课堂网管理中心-大屏目录配置',
            index: 2,
            documentTitle: '同步课堂_大屏目录配置'
          }
        },
        {
          path: 'classroomInspectionTour',
          name: 'ClassroomInspectionTour',
          component: () =>
            import(/* webpackChunkName: "ClassroomInspectionTour" */ '@/views/ClassroomInspectionTour/index.vue'),
          children: [
            {
              path: 'onLineInspectionTour',
              name: 'OnLineInspectionTour',
              component: () =>
                import(
                  /* webpackChunkName: "ClassroomInspectionTour" */ '@/views/ClassroomInspectionTour/OnLineInspectionTour/index.vue'
                ),
              meta: {
                title: '同步课堂网管理中心-教室巡视-在线巡视',
                index: 2,
                documentTitle: '同步课堂_在线巡视'
              }
            },
            {
              path: 'inspectionTourDetail',
              name: 'InspectionTourDetail',
              component: () =>
                import(
                  /* webpackChunkName: "ClassroomInspectionTour" */ '@/views/ClassroomInspectionTour/InspectionTourDetail/index.vue'
                ),
              meta: {
                title: '同步课堂网管理中心-教室巡视-在线巡视',
                index: 2,
                documentTitle: '同步课堂_在线巡视'
              }
            },
            {
              path: 'historicalReplay',
              name: 'HistoricalReplay',
              component: () =>
                import(
                  /* webpackChunkName: "ClassroomInspectionTour" */ '@/views/ClassroomInspectionTour/HistoricalReplay/index.vue'
                ),
              meta: {
                title: '同步课堂网管理中心-教室巡视-在线巡视',
                index: 2,
                documentTitle: '同步课堂_在线巡视'
              }
            }
          ],
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'inspectionTourHistory',
          name: 'InspectionTourHistory',
          component: () =>
            import(
              /* webpackChunkName: "ClassroomInspectionTour" */ '@/views/ClassroomInspectionTour/InspectionTourHistory/index.vue'
            ),
          meta: {
            title: '同步课堂网管理中心-教室巡视-巡视历史',
            index: 2,
            keepAlive: true,
            documentTitle: '同步课堂_巡视历史'
          }
        },
        {
          path: 'inspectionTourHistoryDetail',
          name: 'InspectionTourHistoryDetail',
          component: () =>
            import(
              /* webpackChunkName: "inspectionTourHistoryDetail" */ '../views/ClassroomInspectionTour/InspectionTourHistoryDetail/index.vue'
            ),
          meta: {
            title: '同步课堂网管理中心-教室巡视-巡视历史详情',
            index: 2,
            keepAlive: true,
            documentTitle: '同步课堂_巡视历史'
          }
        },
        {
          path: 'userManagement',
          name: 'UserManagement',
          component: () =>
            import(
              /* webpackChunkName: "PersonnelManagement" */ '../views/PersonnelManagement/UserManagement/index.vue'
            ),
          meta: {
            title: '同步课堂网管理中心-人员管理-用户管理',
            index: 2,
            keepAlive: true,
            documentTitle: '同步课堂_用户管理'
          }
        },
        {
          path: 'administratorConfiguration',
          name: 'AdministratorConfiguration',
          component: () =>
            import(
              /* webpackChunkName: "PersonnelManagement" */ '../views/PersonnelManagement/AdministratorConfiguration/index.vue'
            ),
          meta: {
            title: '同步课堂网管理中心-人员管理-管理员配置',
            index: 2,
            keepAlive: true,
            documentTitle: '同步课堂_管理员配置'
          }
        },
        {
          path: 'teachingAssistantManagement',
          name: 'TeachingAssistantManagement',
          component: () =>
            import(
              /* webpackChunkName: "PersonnelManagement" */ '../views/PersonnelManagement/TeachingAssistantManagement/index.vue'
            ),
          meta: {
            title: '同步课堂网管理中心-人员管理-助教管理',
            index: 2,
            keepAlive: true,
            documentTitle: '同步课堂_助教管理'
          }
        }
      ],
      meta: {
        index: 2
      }
    },
    {
      path: '/Login2',
      name: 'Login2',
      component: () => import(/* webpackChunkName: "Login2" */ '../views/Login.vue'),
      meta: {
        index: 1,
        documentTitle: '同步课堂_管理中心'
      }
    },
    // 产品要求新的登录改成login 旧的改成login2
    {
      path: '/Login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "Login" */ '../views/Login2.vue'),
      meta: {
        index: 1,
        documentTitle: '同步课堂_管理中心'
      }
    },
    {
      path: '/404',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */ '../views/404/404.vue'),
      meta: {
        documentTitle: '同步课堂_智慧树'
      }
    },
    {
      path: '/noPermission',
      name: 'NoPermission',
      component: () => import(/* webpackChunkName: "NoPermission" */ '../views/NoPermission.vue'),
      meta: {
        documentTitle: '同步课堂_智慧树'
      }
    },
    {
      path: '/SupervisionCourse',
      name: 'SupervisionCourse',
      component: () =>
        import(/* webpackChunkName: "SupervisionCourse" */ '../views/CourseManagement/SupervisionCourse.vue'),
      meta: {
        documentTitle: '同步课堂_督学中心'
      }
    },
    {
      path: '/clientSupervisionCourse',
      name: 'ClientSupervisionCourse',
      component: () =>
        import(/* webpackChunkName: "SupervisionCourse" */ '../views/CourseManagement/ClientSupervisionCourse.vue'),
      meta: {
        documentTitle: '同步课堂_督学中心'
      }
    },
    {
      path: '/clientMSC2SupervisionCourse',
      name: 'ClientMSC2SupervisionCourse',
      component: () =>
        import(/* webpackChunkName: "SupervisionCourse" */ '../views/CourseManagement/ClientMSC2SupervisionCourse.vue'),
      meta: {
        documentTitle: '同步课堂_督学中心'
      }
    },
    {
      path: '/LCSupervisionCourse',
      name: 'LCSupervisionCourse',
      component: () =>
        import(/* webpackChunkName: "LCSupervisionCourse" */ '../views/CourseManagement/LCSupervisionCourse.vue'),
      meta: {
        documentTitle: '同步课堂_LC督学中心'
      }
    },
    {
      path: '/dhRJbRbH2451WEiSOoGE4Z0NpTy9',
      name: 'dhRJbRbH2451WEiSOoGE4Z0NpTy9',
      component: () => import(/* webpackChunkName: "LargeScreenDisplay" */ '../views/LargeScreenDisplay.vue'),
      meta: {
        documentTitle: '督导中心'
      }
    },
    {
      path: '/largeThirdScreenCharts',
      name: 'LargeThirdScreenCharts',
      component: () => import(/* webpackChunkName: "LargeScreenDisplay" */ '../views/LargeThirdScreenCharts.vue'),
      meta: {
        documentTitle: '督导中心'
      }
    },
    {
      path: '/LargeThirdScreenChartsTest',
      name: 'LargeThirdScreenChartsTest',
      component: () => import(/* webpackChunkName: "LargeScreenDisplay" */ '../views/LargeThirdScreenChartsTest.vue'),
      meta: {
        documentTitle: '数据大屏测试页'
      }
    },
    {
      path: '/largeScreenDisplayTianjinUniversity',
      name: 'LargeScreenDisplayTianjinUniversity',
      component: () =>
        import(/* webpackChunkName: "LargeScreenDisplay" */ '../views/LargeScreenDisplayTianjinUniversity.vue'),
      meta: {
        documentTitle: '督导中心'
      }
    },
    {
      path: '/largeScreenDisplayTianjinUniversityIframe',
      name: 'LargeScreenDisplayTianjinUniversityIframe',
      component: () =>
        import(/* webpackChunkName: "LargeScreenDisplay" */ '../views/LargeScreenDisplayTianjinUniversityIframe.vue'),
      meta: {
        documentTitle: '督导中心'
      }
    },
    {
      path: '/guideStation',
      name: 'guideStation',
      component: () => import(/* webpackChunkName: "GuideStation" */ '../views/guideStation/GuideStation.vue'),
      meta: {
        documentTitle: '导播台'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.getters['userInfo/token']) {
    if (to.path === '/login' || to.path === 'login2') {
      next(from.path)
    } else {
      if (to.matched.length === 0) {
        next('/404')
      } else {
        next()
      }
    }
  } else {
    if (
      to.path === '/login' ||
      to.path === '/login2' ||
      to.path === '/404' ||
      to.path === '/dhRJbRbH2451WEiSOoGE4Z0NpTy9' ||
      to.path === '/largeThirdScreenCharts' ||
      to.path === '/largeScreenDisplayTianjinUniversity' ||
      to.path === '/largeScreenDisplayTianjinUniversityIframe'
    ) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
